import { IChecklistTask, IChecklistTaskRequestItem } from '@features/Checklist/model/types';

export const prepareChecklistRequestItems = (
    checklist: IChecklistTask[]
): IChecklistTaskRequestItem[] =>
    checklist
        .filter((item) => item.text.trim().length > 0)
        .map<IChecklistTaskRequestItem>(({ id, text, isChecked }, index) => ({
            id,
            text,
            isChecked,
            sortOrder: index + 1,
        }));
